import type { ReactNode } from 'react';

/** Le cadre des écrans d'accès : la marque à gauche, le formulaire à droite. */
export function CadreConnexion({
  titre,
  sousTitre,
  children,
}: {
  titre: string;
  sousTitre: string;
  children: ReactNode;
}) {
  return (
    <div className="grid min-h-full lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)]">
      <aside className="relative hidden flex-col justify-between overflow-hidden bg-nav p-12 text-nav-text-strong lg:flex">
        <img
          src="/logo-vla.svg"
          alt="VLA Énergie"
          className="h-16 w-auto self-start brightness-0 invert"
        />
        <div className="max-w-md">
          <p className="text-[11px] font-semibold tracking-[0.08em] text-nav-muted uppercase">
            VLA Logistique
          </p>
          <p className="mt-3 font-display text-3xl leading-tight font-semibold">
            Les chantiers de séchoirs solaires, de la livraison à la réception.
          </p>
          <p className="mt-4 text-sm text-nav-text">
            Planning des partenaires, avancement étape par étape, fiches entreprises et partenaires.
          </p>
        </div>
        <p className="text-xs text-nav-muted">France, Corse et outre-mer</p>
        <div
          aria-hidden
          className="pointer-events-none absolute -right-24 -bottom-24 size-96 rounded-full bg-brand-nav opacity-20 blur-3xl"
        />
      </aside>

      <main className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <img src="/logo-vla.svg" alt="VLA Énergie" className="mb-8 h-12 w-auto lg:hidden" />
          <h1 className="text-[26px] font-bold">{titre}</h1>
          <p className="mt-1 mb-7 text-[13px] text-muted">{sousTitre}</p>
          {children}
          <p className="mt-10 flex gap-4 text-xs text-faint">
            <a href="/mentions-legales" className="hover:text-ink">
              Mentions légales
            </a>
            <a href="/confidentialite" className="hover:text-ink">
              Confidentialité
            </a>
          </p>
        </div>
      </main>
    </div>
  );
}

export function Alerte({ ton, children }: { ton: 'danger' | 'succes'; children: ReactNode }) {
  return (
    <p
      role={ton === 'danger' ? 'alert' : 'status'}
      className={
        ton === 'danger'
          ? 'rounded-xl border border-danger-border bg-danger-bg px-3.5 py-2.5 text-[13px] text-danger'
          : 'rounded-xl border border-success-border bg-success-bg px-3.5 py-2.5 text-[13px] text-success'
      }
    >
      {children}
    </p>
  );
}
